import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X, Cookie, Check } from 'lucide-react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'receppet_cookie_consent';

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);
    
    useEffect(() => {
        // Check if user already gave consent
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            // Show banner after a short delay
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);
    
    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
            accepted: true,
            timestamp: new Date().toISOString(),
            preferences: {
                necessary: true,
                analytics: true,
                marketing: true
            }
        }));
        setVisible(false);
    };
    
    const handleAcceptNecessary = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
            accepted: true,
            timestamp: new Date().toISOString(),
            preferences: {
                necessary: true,
                analytics: false,
                marketing: false
            }
        }));
        setVisible(false);
    };
    
    if (!visible) return null;
    
    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-2 md:p-4 animate-in slide-in-from-bottom duration-500">
            <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-2xl border border-slate-200 p-3 md:p-6">
                <div className="flex items-start gap-3 md:gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-[#4A90B2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <Cookie className="w-5 h-5 md:w-6 md:h-6 text-[#4A90B2]" />
                    </div>
                    
                    <div className="flex-1 min-w-0">
                        <h3 className="font-semibold text-slate-900 text-sm md:text-base mb-1 md:mb-2">
                            Usamos cookies 🍪
                        </h3>
                        <p className="text-xs md:text-sm text-slate-600 mb-2 md:mb-4 line-clamp-2 md:line-clamp-none">
                            Utilizamos cookies para melhorar sua experiência. Veja nossa{' '}
                            <Link to="/privacy" className="text-[#4A90B2] hover:underline">
                                Política de Privacidade
                            </Link>.
                        </p>
                        
                        <div className="flex flex-wrap gap-2 md:gap-3">
                            <Button
                                onClick={handleAccept}
                                size="sm"
                                className="bg-[#4A90B2] hover:bg-[#3A7A9F] text-white text-xs md:text-sm"
                                data-testid="accept-all-cookies"
                            >
                                <Check className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2" />
                                Aceitar todos
                            </Button>
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={handleAcceptNecessary}
                                className="text-xs md:text-sm"
                                data-testid="accept-necessary-cookies"
                            >
                                Apenas necessários
                            </Button>
                        </div>
                    </div>
                    
                    <button
                        onClick={handleAcceptNecessary}
                        className="p-1 hover:bg-slate-100 rounded-full flex-shrink-0"
                        aria-label="Fechar"
                    >
                        <X className="w-4 h-4 md:w-5 md:h-5 text-slate-400" />
                    </button>
                </div>
            </div>
        </div>
    );
}
